import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";
import { useCookies } from "react-cookie";
import { retrieveIndexHistory } from "../../Services/IndexApiService";
import { Calendar } from "primereact/calendar";
import HistoryIndexData2 from "../../Components/PrimeReact/HistoryIndex/stock-data";
import HistoryPriceChart2 from "../../Components/PrimeReact/HistoryPrice/history-price";
import LogoHeader from "../../Components/PrimeReact/logoBanner";
import { useAuthHeader } from "../../auth/AuthService";
import { toLocalISOString } from "../../utils/DateUtils";

export default function HistoricalIndex() {
    const [cookies, setCookie] = useCookies(['startDate', 'endDate']);
    const {t, i18n} = useTranslation();
    const [startDate, setStartDate] = useState(cookies.startDate ? new Date(cookies.startDate) : new Date(new Date().setMonth(new Date().getMonth() - 2)));
    const [endDate, setEndDate] = useState(cookies.endDate ? new Date(cookies.endDate) : new Date());
    const [price , setPrice] = useState([]);
    const [volume, setVolume] = useState([]);
    const authHeader = useAuthHeader();

    const onChangeSDate = (e) => {
        setStartDate(e.value);
        setCookie('startDate', e.value);
    }

    const onChangeEDate = (e) => {
        setEndDate(e.value);
        setCookie('endDate', e.value);
    }

    async function getHistoryDate() {
        await retrieveIndexHistory(startDate, toLocalISOString(endDate), authHeader())
        .then((response) => {
            let data = response.data.data;
            let price = [];
            let volume = [];
            data.map((v) => {
                v[0] = (new Date(v[0])).getTime();
                if (v[6] == 2) {
                    v[1] = v[2] = v[3] = v[4];
                }
                price.push([
                    v[0],
                    v[1],
                    v[2],
                    v[3],
                    v[4]
                ]);
                volume.push([v[0], v[5]]);
            });
            setPrice(price);
            setVolume(volume);
        })
        .catch((error) => {console.log(error)});
    }

    function init() {
        !cookies.startDate && setCookie('startDate', startDate);
        !cookies.endDate && setCookie('endDate', endDate);
    }

    useEffect(() => {
        getHistoryDate();
    }, [startDate.toISOString(), endDate.toISOString(), i18n.language]);

    useEffect(() => {
        init();
    }, [])

    return (
        <>
            <LogoHeader />

            <div className='col-12 -mt-3'>
                <div className="card p-4 shadow-3 border-round-lg bg-card">
                    <div className='grid mb-4'>
                        <div className='col-6 md:col-3'>
                            <Calendar value={startDate} onChange={onChangeSDate} showIcon className="w-full border-round-lg"/>
                        </div>
                        <div className='col-6 md:col-3'>
                            <Calendar value={endDate} onChange={onChangeEDate} showIcon className="w-full border-round-lg"/>
                        </div>
                    </div>
                    <HistoryIndexData2 lang={i18n.language} />
                    <HistoryPriceChart2
                        price={price}
                        volume={volume}
                        label = {{'title': t('Historical Index'), 'volume': t('Volume') , 'price': t('Index')}}
                    />
                    <div className="text-yellow-500 pt-3 font-bold text-sm">
                        {t('Trading Volume Remark')}
                    </div>
                </div>
            </div>
        </>
    )
}